module.exports = __webpack_public_path__ + "img/vila-andreja-video.19cf910f.png";